/*
 * @Author: kian
 * @Date: 2021-11-11 08:56:44
 * @LastEditors: kian
 * @LastEditTime: 2021-12-10 09:32:51
 * @Description:
 */
// eslint-disable-next-line import/no-named-as-default
import to from 'await-to-js';

export default function ({ $axios, app, $sentry, req }, inject) {
  $axios.defaults.timeout = 20000;
  // 强制 axios 不使用 follow-redirects adpter
  // 因为这个库存在内存泄漏tcp连接过多必现
  // 设置成0会默认使用nodejs内部实现
  $axios.defaults.maxRedirects = 0;
  $axios.onRequest(config => {
    const locale = app.i18n.getLocaleCookie();
    config.headers.common['Client-Lang'] = locale || 'zh-cn';
    config.headers.common['platform'] = 'web';
    config.headers.common['shortVersion'] = '10.0.0';
    if (process.server) {
      // 用于处理在服务端请求的接口需要前端cookie的问题
      config.headers.common['Cookie'] = req?.headers?.cookie || '';
    }

    return config;
  });

  $axios.onResponse(response => {
    const res = response.data;
    // 因为偶尔服务端宕机,会返回一个html页面
    if (typeof res !== 'object') {
      const err = new Error('接口错误' + res.data);
      if (process.env.NODE_ENV === 'production') {
        $sentry.captureException(err);
      }

      return {
        message: '服务端错误:' + res,
        statusCode: 500,
        totalCount: 0,
        result: null,
      };
    }
    return res;
  });

  $axios.onError(error => {
    const err = error?.toJSON() || error?.config || { message: '错误的请求' };
    if (process.env.NODE_ENV === 'production') {
      $sentry.captureException(err);
    }

    return Promise.reject(err);
  });

  // 注入实例 $http
  inject('http', c => {
    return to(
      $axios({
        ...$axios.defaults,
        ...c,
      })
    );
  });
}
